import { render } from "./RegistrarAfilicion.vue?vue&type=template&id=ca4eeb88&scoped=true"
import script from "./RegistrarAfilicion.vue?vue&type=script&lang=js"
export * from "./RegistrarAfilicion.vue?vue&type=script&lang=js"

import "./RegistrarAfilicion.vue?vue&type=style&index=0&id=ca4eeb88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4eeb88"]])

export default __exports__